import { render, staticRenderFns } from "./friend.vue?vue&type=template&id=adcfdcb8"
import script from "./friend.vue?vue&type=script&lang=js"
export * from "./friend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports